/**
 * Owner: Masa Bayu
 * File: use-breakpoint-band.ts
 * Date:Time: 2026-09-15 20:04
 * Description: Live breakpoint band hook for QXRead shell responsive evidence.
 */

import { useEffect, useState } from 'react';
import type { QxreadBreakpointBand } from '@qx/qxread-core';
import { resolveQxreadBreakpointBand } from './responsive-band';
import { resolveQxreadShellLayout, type QxreadShellLayoutContract } from './shell-density';

export function useBreakpointBand(): {
  readonly band: QxreadBreakpointBand;
  readonly layout: QxreadShellLayoutContract;
} {
  const [band, setBand] = useState<QxreadBreakpointBand>(() =>
    resolveQxreadBreakpointBand(typeof window === 'undefined' ? 1024 : window.innerWidth),
  );

  useEffect(() => {
    const update = () => {
      setBand(resolveQxreadBreakpointBand(window.innerWidth));
    };
    update();
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('resize', update);
    };
  }, []);

  return { band, layout: resolveQxreadShellLayout(band) };
}
